import graphql from './graphql';

const query = /* GraphQL */ `
  query CourseTerminal_listByCourse($courseId: ID!) {
    CourseTerminal_listByCourse(courseId: $courseId) {
      id
      status
      terminalId
      Terminal {
        id
        name
      }
    }
  }
`;

const CourseTerminalListByCourse = async ({ courseId = null }) =>
  graphql(query, { courseId }).then(
    // eslint-disable-next-line camelcase
    ({ CourseTerminal_listByCourse }) => CourseTerminal_listByCourse
  );

export default CourseTerminalListByCourse;
